export const resolveIsPayerChosen = (value: string) => value !== '';
